import React from 'react';
import { CustomImage as Image } from 'components/shared/custom-image';
import CustomLink, { CustomLinkProps } from 'components/shared/CustomLink';
import { Container } from '..';
import { Body2 } from './styleConstants';
import styles from './ProductCards.module.css';

const cx = (...parts: (string | false | undefined)[]) =>
  parts.filter(Boolean).join(' ');

const BuyNowButton = React.forwardRef<
  HTMLAnchorElement,
  CustomLinkProps & { className?: string }
>(function BuyNowButton({ className, children, ...rest }, ref) {
  return (
    <CustomLink
      ref={ref}
      className={cx(styles.buyNowButton, className)}
      {...rest}
    >
      {children}
    </CustomLink>
  );
});

type ProductCardsData = {
  image: string;
  alt: string;
  imageHover: string;
  title: string;
  href: string;
};

const cardsData: ProductCardsData[] = [
  {
    image: 'web_v2/uh-x-diesel/product/updated/cryo.png',
    alt: 'Ultrahuman Diesel CRYO',
    imageHover: 'web_v2/uh-x-diesel/product/updated/cryo.png',
    title: 'CRYO',
    href: '/diesel-ultrahuman-ring/buy/?color=cryo',
  },
  {
    image: 'web_v2/uh-x-diesel/product/updated/phantom.png',
    alt: 'Ultrahuman Diesel PHANTOM',
    imageHover: 'web_v2/uh-x-diesel/product/updated/phantom.png',
    title: 'PHANTOM',
    href: '/diesel-ultrahuman-ring/buy/?color=phantom',
  },
];

const ProductCard = (props: ProductCardsData) => {
  return (
    <div className={styles.productCard}>
      <Image src={props.image} alt={props.alt} height={500} width={500} />
      <div className={styles.textContent}>
        {/* <h4>{props.title}</h4> */}
        <Body2 $color="white">{props.title}</Body2>
        <BuyNowButton
          href={{
            pathname: props.href.split('?')[0],
            query: {
              color: props.href.split('?')[1].split('=')[1],
            },
          }}
          aria-label={`Buy ${props.title} now`}
        >
          <span style={{ position: 'relative', zIndex: 2 }}>BUY NOW</span>
        </BuyNowButton>
      </div>
    </div>
  );
};

const ProductCards = ({ className }: { className?: string }) => {
  return (
    <section className={cx(styles.productCards, className)}>
      <Container className={styles.container}>
        {cardsData.map((e) => {
          return <ProductCard key={e.href} {...e} />;
        })}
      </Container>
    </section>
  );
};

export default ProductCards;
export { BuyNowButton };
